<app-logo-area
  [breadcrumbs]="[{'display': 'Content Platform', commands: null}]"></app-logo-area>
<main>

  <app-headline-section [title]="'Aspera Connectors'">
  </app-headline-section>

  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-8">
          <p class="cl-p-large">
            Every Aspera share we deliver to. Open one to browse its files and follow its transfers.
          </p>
        </div>
      </div>
    </div>
  </section>

  @if (error()) {
    <section class="cl-section cl-section-regular">
      <div class="container"><div class="row"><div class="col-12">
        <p class="cl-p-regular cl-color-brick">Could not load the Aspera endpoints: {{ error() }}</p>
      </div></div></div>
    </section>
  }

  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="cl-table-scroll">
            <table class="cl-table-data">
              <thead>
                <tr>
                  <th class="cl-table-head">Portal</th>
                  <th class="cl-table-head">What we do</th>
                  <th class="cl-table-head">Session</th>
                  <th class="cl-table-head">Account</th>
                  <th class="cl-table-head">Last swept</th>
                </tr>
              </thead>
              <tbody>
                @if (loading()) {
                  <tr class="cl-tr-no-data"><td colspan="100"><div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i></div></td></tr>
                }
                @for (endpoint of endpoints(); track endpoint.id) {
                  <tr>
                    <td>
                      <a [routerLink]="['/o', organization()?.id, 'aspera-endpoints', endpoint.id]">{{ endpoint.name }}</a>
                      <p>{{ endpoint.share }}</p>
                    </td>
                    <td>
                      @if (endpoint.kind) {
                        <span class="cl-badge cl-badge-sm cl-color-steel" [title]="endpoint.kindHint">{{ endpoint.kind }}</span>
                      } @else {
                        —
                      }
                    </td>
                    <td>
                      @if (endpoint.session === 'logged-in') {
                        <span class="cl-color-sea">Logged in</span>
                      } @else if (endpoint.session === 'mfa') {
                        <span class="cl-color-sun">MFA required</span>
                      } @else {
                        <span class="cl-color-brick">Signed out</span>
                      }
                    </td>
                    <td>{{ endpoint.account || '—' }}</td>
                    <td class="cl-td-time"><app-date [value]="endpoint.lastSweepAt" empty="—" /></td>
                  </tr>
                }
                @if (!loading() && endpoints().length === 0 && !error()) {
                  <tr class="cl-tr-no-data"><td colspan="100">No Aspera endpoints are available to you.</td></tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
